// extracted by mini-css-extract-plugin
export var icon = "_78-1";
export var subtext = "_78-0";